export default __webpack_public_path__ + "static/0206-7aef4831fc4c4e14f8111c5219f0d769.png";